import { useMutation } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { UserPlatformEnum } from '../enums/platform.enum';
import { useChatContext } from '../providers/Chat/Chat.provider';
import { authService, storkAuthService } from '../services/auth.service';
import { rememberAccessToken } from '../utils/agentsRequest';

export const useSwitchPlatform = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { setReset } = useChatContext();

    return useMutation({
        mutationFn: async (targetPlatform: UserPlatformEnum) => {
            // Exchange the current token against the target platform auth system.
            const targetService = targetPlatform === UserPlatformEnum.STORK ? storkAuthService : authService;
            return targetService.exchangeExternalToken();
        },
        onSuccess: ({ accessToken, refreshToken }, targetPlatform) => {
            rememberAccessToken(accessToken);
            if (refreshToken) {
                localStorage.setItem('refreshToken', refreshToken);
            } else {
                localStorage.removeItem('refreshToken');
            }

            if (targetPlatform === UserPlatformEnum.STORK) {
                localStorage.setItem('isStorkUser', 'true');
            } else {
                localStorage.removeItem('isStorkUser');
            }

            setReset(true);
            queryClient.removeQueries({ queryKey: ['conversation'] });
            queryClient.removeQueries({ queryKey: ['conversations'] });

            void (async () => {
                try {
                    await queryClient.refetchQueries({ queryKey: ['userInfo'] });
                } finally {
                    navigate('/chat', { replace: true });
                }
            })();
        },
    });
};
